import { Bank, CashType, ChequeStatusType } from "../types";
import { FactorType } from "../types/factor";
import {
  cashTypeToString,
  chequeStatusToString,
  factorTypeToString,
} from "../utils";

export const NAV_WIDTH = 272;

export const BANKS: Array<Bank> = [
  { name: "mellat", fa: "ملت" },
  { name: "refah", fa: "رفاه" },
  { name: "melli", fa: "ملی ایران" },
  { name: "sepah", fa: "سپه" },
  { name: "sanat_o_madan", fa: "صنعت و معدن" },
  { name: "keshavarzi", fa: "کشاورزی" },
  { name: "maskan", fa: "مسکن" },
  { name: "saderat", fa: "صادرات" },
  { name: "taavon", fa: "تعاون" },
  { name: "post", fa: "پست بانک" },
  { name: "eghtesad_e_novin", fa: "اقتصاد نوین" },
  { name: "parsian", fa: "پارسیان" },
  { name: "karafarin", fa: "کارآفرین" },
  { name: "saman", fa: "سامان" },
  { name: "sina", fa: "سینا" },
  { name: "khavarmiane", fa: "خاور میانه" },
  { name: "shahr", fa: "شهر" },
  { name: "dey", fa: "دی" },
  { name: "tejarat", fa: "تجارت" },
  { name: "ayande", fa: "آینده" },
  { name: "gardeshgari", fa: "گردشگری" },
  { name: "iranzamin", fa: "ایران زمین" },
  { name: "ghavamin", fa: "قوامین" },
  { name: "ansar", fa: "انصار" },
  { name: "sarmaye", fa: "سرمایه" },
  { name: "pasargad", fa: "پاسارگاد" },
  { name: "iranvenezuela", fa: "ایران-ونزوئلا" },
  { name: "mehriran", fa: "قرض الحسنه مهر ایران" },
  { name: "resalat", fa: "قرض الحسنه رسالت" },
  { name: "etebari_caspian", fa: "اعتباری کاسپین" },
  { name: "etebari_tosee", fa: "اعتباری توسعه" },
  { name: "etebari_kosar", fa: "اعتباری کوثر مرکزی" },
  { name: "etebari_melal", fa: "اعتباری ملل" },
  { name: "etebari_noor", fa: "اعتباری نور" },
];

export const CHEQUE_STATUS_LIST: Array<ChequeStatusType> = [
  {
    status: "confirmed",
    fa: chequeStatusToString("confirmed"),
  },
  {
    status: "delivered",
    fa: chequeStatusToString("delivered"),
  },
  {
    status: "received",
    fa: chequeStatusToString("received"),
  },
  {
    status: "spent",
    fa: chequeStatusToString("spent"),
  },
];

export const FACTOR_TYPE_LIST: Array<FactorType> = [
  {
    name: "received",
    fa: factorTypeToString("received"),
  },
  {
    name: "spent",
    fa: factorTypeToString("spent"),
  },
];

export const CASH_TYPE_LIST: Array<CashType> = [
  {
    name: "received",
    fa: cashTypeToString("received"),
  },
  {
    name: "spent",
    fa: cashTypeToString("spent"),
  },
];

export const SIDE_PANEL_ROOM_IDX = 0;
export const CHAT_PAGE_ROOM_IDX = 1;
